import TrainingPlans from './ListTrainingPlans';
export default TrainingPlans;
